import { Box, CircularProgress } from '@mui/material';

import { theme } from '@store';
import { History } from '@components';

import { usePatientHistory } from '@views/pages/Patient/components/PatientHistory/hooks';

export const PatientHistory = ({
  patient_id,
  tabPanelInstrumentHeight,
  isTabOpen,
}: {
  patient_id: string;
  tabPanelInstrumentHeight: number;
  isTabOpen: boolean;
}) => {
  const {
    setHistoryPage,
    historyList,
    count,
    historyPage,
    handleOpenTaskDetails,
    isLoading,
  } = usePatientHistory(patient_id, isTabOpen);

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.common.white,
        p: 3,
        border: '1px solid rgba(0, 0, 0, 0.12)',
      }}
    >
      <Box
        sx={{
          maxHeight: `calc(100vh - ${tabPanelInstrumentHeight + 62}px)`,
          overflowX: 'auto',
        }}
      >
        {isLoading ? (
          <Box
            sx={{
              height: `calc(100vh - ${tabPanelInstrumentHeight + 62}px)`,
              display: 'grid',
              placeItems: 'center',
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <History
            history={historyList}
            count={count}
            page={historyPage}
            changePage={setHistoryPage}
            handleOpenTaskDetails={handleOpenTaskDetails}
          />
        )}
      </Box>
    </Box>
  );
};
